import { render, staticRenderFns } from "./VDataTable.vue?vue&type=template&id=1734c4e8&scoped=true"
import script from "./VDataTable.vue?vue&type=script&lang=ts"
export * from "./VDataTable.vue?vue&type=script&lang=ts"
import style0 from "./VDataTable.vue?vue&type=style&index=0&id=1734c4e8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1734c4e8",
  null
  
)

export default component.exports